module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-spinner"
  }, [_c('div', {
    staticClass: "button-spinner__spinner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd1c280c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ButtonSpinner.vue
// module id = 2140
// module chunks = 1